export const LIST_ACCOUNTS_SLICE = "listAccountsSlice";
export interface IListAccountsSlice {
  isGot: boolean;
  accounts: IAccount[];
}
export interface IAccount {
  _id: string;
  phone: string;
  email: string;
  fullName: string;
  role: string;
  isActive: boolean;

  createdAt: Date;
  updatedAt: Date;
}
export const ACCOUNTS_URL = "/accounts";
